"use client";

import { useSearchParams } from "next/navigation";
import { TargetCategoryNameType } from "../../../../constants/apis/endpoints";
import { useEffect, useState } from "react";
import { microCmsAuthType } from "../../../../types/microCmsAuthType";
import microCmsGetAuth from "../../../../constants/apis/microCmsGetApiKey";
import useFetchContentById from "../../../../hooks/useFetchContentById.hooks";
import DetailPagePagination from "../../../../components/molecules/DetailPagePagination/DetailPagePagination";
import META from "../../../../constants/siteInfo/meta";
import plt_addDynamicTitleToBreadcrumbs from "../../../../libs/plt_addDynamicTitleToBreadcrumbs";

const BlogDetailContent = (props: TargetCategoryNameType) => {
  const {targetEndpointId, targetCategoryName} = props;
  const microCMSAuth: microCmsAuthType = microCmsGetAuth;

  const searchParams = useSearchParams();
  const contentId = searchParams.get("id") || '';
  const draftKey = searchParams.get("draftKey") || '';

  const [isBlogContentsLoaded, setIsBlogContentsLoaded] = useState(false);

  const [response, setResponse] = useState<any>();

  useEffect(() => {
    const FetchData = async () => {
      const content = await useFetchContentById(microCMSAuth, targetEndpointId, contentId, draftKey);
      setResponse(content.responseBody.contents);
      
      document.title = content.responseBody.contents.title + " | " + META.siteTitle;
      document.querySelector('meta[name="description"]')?.setAttribute("content", content.responseBody.contents.title + " | " + META.siteTitle);

      plt_addDynamicTitleToBreadcrumbs();
    }
    FetchData();
  }, [contentId]);

  return (
    <>
      {response ? (
        <div>
          {/* debug code */}
          {/* {JSON.stringify(response)} */}
          <div className="postcontent">
            <div className="post-title">{response.title}</div>
            <div className="paragraphText" dangerouslySetInnerHTML={{ __html: response.content }} />
          </div>

          <div>
          <DetailPagePagination
            endpointId={targetEndpointId}
            contentId={contentId}
            categoryName={targetCategoryName}
          />
          </div>
        </div>
      ) : (
        null
      )}
    
    </>
  )
}

export default BlogDetailContent;